import { render, staticRenderFns } from "./emergencySummary.vue?vue&type=template&id=7bef417d&scoped=true&"
import script from "./emergencySummary.vue?vue&type=script&lang=js&"
export * from "./emergencySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef417d",
  null
  
)

export default component.exports